<template>
    <div id="WordDetailMobile">
        <nav-bar style="background-color: #0092FF">
            <link-mobile slot="left" link="/WordMobile"><</link-mobile>
            <div slot="center">词典</div>
            <link-mobile slot="right" link="/WordMoreMobile"><i class="el-icon-more"></i></link-mobile>
        </nav-bar>


        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                :pull-up-load="true">
            <el-input ref="inputWord" @focus="bbo" @blur="cco" autofocus="autofocus" placeholder="请拼写单词" v-model="inputWord" class="input-with-select" @keyup.enter.native="searchWordd">
                <el-button slot="prepend" icon="el-icon-caret-left" @click="searchlastWordd"></el-button>
                <el-button slot="prepend" icon="el-icon-caret-right" @click="searchnextWordd"></el-button>

                <el-button slot="append" icon="el-icon-search" @click="searchWordd"></el-button>
                <el-button slot="append" icon="el-icon-refresh" @click="clearInput"></el-button>

            </el-input>
            <div :style="{'display':'flex','background-color': '#AED6DE'}">
<!--                <div class="demo-image__placeholder">-->
<!--                    <div class="block">-->
<!--                        <el-image>-->
<!--                            <div slot="error" class="image-slot">-->
<!--                                <i class="el-icon-picture-outline"></i>-->
<!--                            </div>-->
<!--                        </el-image>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="demo-image__error" :style="{'width':'160px','height':'80px'}">
                    <div class="block">
                        <el-image
                                fit="contain"
                                style="width: 100px; height: 100px"
                                :src="src"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>

                    </div>
                </div>
                <div :style="{'flex':'1','margin-left':'15px','text-align':'left'}">
                    <el-row :gutter="20" :style="{'height':'35px'}">
                        <el-col :span="24" :style="{'font-size':'35px'}"><div class="grid-content bg-purple">{{this.$store.state.a.words.word}}</div></el-col>

                    </el-row>
                    <el-row justify="end">
                        <el-col :span="24"><div class="grid-content bg-purple">{{this.$store.state.a.words.cixing}}</div></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24"><div class="grid-content bg-purple">{{this.$store.state.a.words.yinjie}}</div></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24"><div class="grid-content bg-purple">{{this.$store.state.a.words.yinbiao}}</div></el-col>
                    </el-row>
<!--                    <el-row :gutter="20" :style="{'line-height':'35px'}">-->
<!--                        <el-col :span="12"><div class="grid-content bg-purple">{{this.$store.state.a.words.yinjie}}</div></el-col>-->

<!--                        <el-col :span="8"><div class="grid-content bg-purple">{{this.$store.state.a.words.yinbiao}}</div></el-col>-->
<!--                    </el-row>-->

                </div>
            </div>
            <div >
                <el-row style="background-color: #79B6E0">
                    <el-col :span="24" :style="{'line-height':'35px'}"><div class="grid-content bg-purple">{{this.$store.state.a.words.fanyi}}</div></el-col>
                </el-row>
                <el-row style="background-color: #008AFF">
                    <el-col :span="24"><div class="grid-content bg-purple-dark">{{this.$store.state.a.words.ciyuan}}</div></el-col>
                </el-row>
            </div>



        </Scroll>
    </div>
</template>

<script>
    import NavBar from "../../../components/navbar/NavBar";
    import Scroll from "../../../components/scroll/Scroll";
    import LinkMobile from "../../../components/link/LinkMobile";
    export default {
        name: "WordDetailMobile",
        components:{
            NavBar,
            Scroll,
            LinkMobile,
        },
        data(){
            return{
                inputWord:'',
                reIndex:'',
            }
        },
        computed:{
            src(){
                return "http://heiline.ltd/ademo/pic/"+this.$store.state.a.searchWord+".jpg";
            },

        },
        mounted() {

        },
        activated(){
            this.reIndex=this.$store.state.a.currentCardItemIndex;


        },
        deactivated(){
            this.$store.commit('setCurrentCardItemIndex',this.reIndex);
        },
        methods: {
            bbo() {
                this.$store.commit('bbb')
            },
            cco() {
                this.$store.commit('ccc')
            },
            searchWordd(){
                this.$store.dispatch('requireWord',this.inputWord)
            },
            nextPractise() {
                this.$store.dispatch('requireWord',this.inputWord)
            },
            clearInput(){
                this.$refs.inputWord.value='';
            },
            searchlastWordd(){
                let aa=this.$store.state.a.currentCardItemIndex;
                if(aa > 0){
                    aa--;
                }


                this.$store.commit('setCurrentCardItemIndex',aa);
                this.$store.dispatch('requireWord',this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].word);
            },
            searchnextWordd(){
                let bb=this.$store.state.a.currentCardItemIndex;
                if(bb< this.$store.getters.currentCardList.length-1){
                    bb++;
                }

                this.$store.commit('setCurrentCardItemIndex',bb);
                this.$store.dispatch('requireWord',this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].word);
            },

        }
    }
</script>

<style scoped>
    #WordDetailMobile{
        height: 100vh;
    }
    .wrapper{
        position: relative;
        height: calc(100% - 93px);
        /*height: 580px;*/
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
        position: relative;
        padding-left: 0px;
    }
</style>